// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__26Bo2","label":"Completed_label__2M-s3"};